import React from 'react';

const Logo = ({ size = 'lg', className = '' }) => {
	const sizes = {
		sm: 'text-2xl',
		md: 'text-3xl',
		lg: 'text-4xl',
		xl: 'text-5xl'
	};

	return (
		<div className={`font-bold ${sizes[size]} ${className}`}>
			<span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
				Resume
			</span>
			<span className="text-gray-900 dark:text-white">ly</span>
		</div>
	);
};

export default Logo;


